import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from './authentication.guard';
import { CenterComponent } from './pages/center/center/center.component';
import { DashboardComponent } from './pages/dashboard/dashboard/dashboard.component';
import { HcpComponent } from './pages/hcp/hcp/hcp.component';
import { LoginPageComponent } from './pages/login/login-page/login-page.component';
import { NewProjectComponent } from './pages/new-project/new-project/new-project.component';
import { PageNotFoundComponent } from './pages/not-found/page-not-found/page-not-found.component';
import { OptInComponent } from './pages/opt-in/opt-in/opt-in.component';
import { ProjectReviewComponent } from './pages/project/project-review/project-review.component';
import { ReportPageComponent } from './pages/report/report-page/report-page.component';
import { SupportPageComponent } from "./pages/support/support-page/support-page.component";
import { SystemSettingsComponent } from './pages/system-settings/system-settings/system-settings.component';

interface TRoutePaths {
  dashboard: string;
  root: string;
  newProject: string;
  project: string;
  systemSettings: string;
  support: string;
  center: string;
  login: string;
  notFound: string;
  hcp: string;
  report: string;
  optIn: string;
}

export const ROUTES_PATHS: TRoutePaths = {
  root: '',
  login: 'login',
  optIn: 'opt-in',
  dashboard: 'dashboard',
  newProject: 'new-project',
  project: 'project',
  systemSettings: 'system-settings',
  center: 'center',
  hcp: 'hcp',
  report: 'report',
  support: 'support',
  notFound: '**',
};

const routes: Routes = [
  { path: ROUTES_PATHS.root, component: DashboardComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.login, component: LoginPageComponent },
  { path: ROUTES_PATHS.optIn, component: OptInComponent },
  { path: ROUTES_PATHS.dashboard, component: DashboardComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.newProject, component: NewProjectComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.project, component: ProjectReviewComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.systemSettings, component: SystemSettingsComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.center, component: CenterComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.hcp, component: HcpComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.report, component: ReportPageComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.support, component: SupportPageComponent, canActivate: [AuthenticationGuard] },
  { path: ROUTES_PATHS.notFound, component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
